import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  successMessage: 'Instructor assigned successfully',
  successRemoveMessage: 'Instructor removed successfully',
  errorMessage: 'Failed to assign instructor',
  errorRemoveMessage: 'Failed to remove instructor',
  currentInstructor: 'Current instructor',
  eligibleInstructors: 'Eligible instructors',
  assignInstructor: 'Assign instructor',
  notPublished: 'To add instructors you need to publish this course',
  removeInstructor: 'Remove instructor',
  removeInstructorConfirmation:
    'Are you sure you want to remove the instructor from this course?',
  noInstructorTitle: 'No instructor assigned',
  noInstructorSubtitle: 'Select someone from the list below.',
  assignHeading: 'Assign an instructor',
  replaceHeading: 'Replace with',
  oneInstructorHint: 'A course has one instructor at a time.',
  searchInstructors: 'Search instructors',
  replaceInstructor: 'Replace instructor',
  selectToAssign: 'Select an instructor to assign.',
  noResults: 'No results found',
  instructorsCount: (count: number) =>
    `${count} ${count === 1 ? 'instructor' : 'instructors'}`,
};

const welsh = {
  successMessage: "Hyfforddwr wedi'i dyrannu'n llwyddiannus",
  successRemoveMessage: 'Instructor removed successfully',
  errorRemoveMessage: 'Failed to remove instructor',
  errorMessage: "Methwyd â rhoi'r hyfforddwr",
  currentInstructor: 'Hyfforddwr presennol',
  eligibleInstructors: 'Hyfforddwyr cymwys',
  assignInstructor: 'Dyrannu hyfforddwr',
  notPublished: "I ychwanegu hyfforddwyr, mae angen i chi gyhoeddi'r cwrs hwn",
  removeInstructor: 'Remove instructor',
  removeInstructorConfirmation:
    'Are you sure you want to remove the instructor from this course?',
  noInstructorTitle: "Dim hyfforddwr wedi'i ddyrannu",
  noInstructorSubtitle: "Dewiswch rywun o'r rhestr isod.",
  assignHeading: 'Dyrannu hyfforddwr',
  replaceHeading: 'Amnewid â',
  oneInstructorHint: 'Un hyfforddwr sydd gan gwrs ar y tro.',
  searchInstructors: 'Chwilio hyfforddwyr',
  replaceInstructor: 'Amnewid hyfforddwr',
  selectToAssign: "Dewiswch hyfforddwr i'w ddyrannu.",
  noResults: "Dim canlyniad wedi'i ganfod",
  instructorsCount: (count: number) =>
    `${count} ${count === 1 ? 'hyfforddwr' : 'hyfforddwyr'}`,
};

export const courseInstructorText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
